var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m5.143 7.73l2.726 8.907a.71.71 0 0 0 .674.506H9.95a.71.71 0 0 0 .656-.454l1.382-3.537l.004-.006l.007-.002l.006.002l.005.006l1.398 3.54a.71.71 0 0 0 .656.45h1.344c.307 0 .58-.202.673-.501l1.311-4.212h-2.237l-.382 1.258l-.004.005a.01.01 0 0 1-.013.001l-.004-.005l-1.256-2.86a1.62 1.62 0 0 0-2.953-.006l-1.33 2.866l-.004.005a.012.012 0 0 1-.017-.006L7.434 7.714h-2.28a.012.012 0 0 0-.01.016m10.404 3.413h2.247l1.063-3.413a.01.01 0 0 0-.002-.01a.01.01 0 0 0-.01-.006H16.59z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoo);
export default __webpack_public_path__ + "static/media/woo.0c18a3c1d84bd90c5818154b8124d8ad.svg";
export { ForwardRef as ReactComponent };